module.exports = __webpack_public_path__ + "static/media/background_RUS.1fb657e5.jpg";